/** History's subtabs (CT-5724), child routes of the Activity-kind tab: `activity/timeline`, `activity/notes`. */
export const HISTORY_SUBTABS = Object.freeze(['timeline', 'notes']);
export const DEFAULT_HISTORY_SUBTAB = 'timeline';

/** From notes chips, in the prototype's order. */
export const NOTES_FEED_QUICK_FILTERS = Object.freeze(['all', 'summaries', 'topics', 'interpretations']);

/** What a search on From notes covers: the heading, the reading and where it came from. */
export const NOTES_SEARCH_FIELDS = Object.freeze(['title', 'text', 'origin']);

/** The two things Draft can start, and the Concierge intent each carries (CT-5721). */
export const DRAFT_INTENTS = Object.freeze({ email: 'draft_email', sms: 'draft_sms' });

/**
 * Deep links other tickets send here: `?new=note|call|meeting` (CT-5715's empty
 * state) opens that form once; `?event=<id>` (CT-5716's "Open in History")
 * highlights that event once.
 */
export const HISTORY_NEW_PARAM = 'new';
export const HISTORY_EVENT_PARAM = 'event';
export const HISTORY_NEW_FORMS = Object.freeze(['note', 'call', 'meeting']);

/**
 * How a logged call or meeting went (CT-5724, the prototype's Outcome chips), by
 * kind. Fixed product values, hence i18n keys (`history.form.outcomes.*`).
 */
export const INTERACTION_OUTCOMES = Object.freeze({
  call: Object.freeze(['reached', 'no_answer', 'left_voicemail', 'wrong_number']),
  meeting: Object.freeze(['held', 'no_show', 'rescheduled']),
});
